<div class="content-container">
    <div class="title d-inline-flex w-100">
        SASS Form Example
    </div>
    <div class="content">
        <form [formGroup]="matForm" autocomplete="off">
            <div class="row mb-3">
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Text Box" nameForControl="textBox" />
                </div>
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Text Box 2" nameForControl="textBox2" />
                </div>
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Text Box Disabled" nameForControl="textBoxDisabled" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Phone Number" nameForControl="phone" [maskType]="maskType.phone"/>
                </div>
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Phone Number 2" nameForControl="phone2" [maskType]="maskType.phone"/>
                </div>
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Phone Number Disabled" nameForControl="phoneDisabled" [maskType]="maskType.phone" />
                </div> 
            </div>
            <div class="row mb-3">
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Full Social Number" nameForControl="social" [maskType]="maskType.social"/>
                </div>
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Full Social Disabled" nameForControl="socialDisabled" [maskType]="maskType.last4WithMask" />
                </div> 
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Social Last 4" nameForControl="socialLast4" [maxLength]=4 [maskType]="maskType.numericValues"/>
                </div>
                <div class="col-2">
                    <mwp-input [form]="matForm" labelName="Social Last 4 Disabled" nameForControl="socialLas4Disabled" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-4">
                    <mwp-dropdown-enum [form]="matForm" labelName="Home State" nameForControl="dropDown" [dataEnum]="usStates" />
                </div>
                <div class="col-4">
                    <mwp-dropdown-enum [form]="matForm" labelName="Gender" nameForControl="dropDownRequired" [dataEnum]="genders" />
                </div>
                <div class="col-4">
                    <mwp-dropdown-enum [form]="matForm" labelName="Random State" nameForControl="dropDownDisabled" [dataEnum]="usStates" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-4">
                    <mwp-datepicker [form]="matForm" labelName="Date" nameForControl="date" />
                </div>
                <div class="col-4">
                    <mwp-datepicker [form]="matForm" labelName="Date Required" nameForControl="dateRequired" />
                </div>
                <div class="col-4">
                    <mwp-datepicker [form]="matForm" labelName="Date Disabled" nameForControl="dateDisabled" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-4">
                    <mwp-textarea [form]="matForm" labelName="Text Area" nameForControl="textarea" />
                </div>
                <div class="col-4">
                    <mwp-textarea [form]="matForm" labelName="Text Area Required" nameForControl="textareaRequired" />
                </div>
                <div class="col-4">
                    <mwp-textarea [form]="matForm" labelName="Text Area Disabled" nameForControl="textareaDisabled" />
                </div>
            </div>
        </form>
    </div>
</div>